import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const PersonalDataModule = {
  namespaced: true,
  state: {
    view: 'viewPersonalData'
  },
  getters: {
    getView: state => {
      return state.view
    }
  },
  actions: {
    async changePersonalDataDeprecated ({ commit, state }, newCustomer) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation personalData ($addressInput: AddressInput!, $changeEmailInput: ChangeEmailInput!) {
          changeAddress (address: $addressInput){
            street,
            houseNumber,
            zip,
            city,
            supplement
          },
          changeEmail(changeEmail: $changeEmailInput)
        }`,
        variables: {
          addressInput: {
            city: newCustomer.address.city,
            houseNumber: newCustomer.address.houseNumber,
            street: newCustomer.address.street,
            supplement: newCustomer.address.supplement,
            zip: newCustomer.address.zip
          },
          changeEmailInput: {
            email: newCustomer.email
          }
        },
        update: (cache) => {
          Object.keys(cache.data.data).forEach(key => {
            if (key.match(/currentCustomer/)) {
              cache.data.delete(key)
            }
          })
        }
      }
      ).then((response) => {
        commit('clearMessages', {}, { root: true })
        commit('Transaction/removeTransactionId', 'personalData', { root: true })
        state.view = 'personalDataChangeSuccess'
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async changePersonalData ({ commit, state }, newCustomer) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation personalData ($contactInput: ChangeContactInput!) {
          changeContact (changeContact: $contactInput) {
            address,
            addressCorrected,
            phoneNumber,
            email
          }
        }`,
        variables: {
          contactInput: {
            address: {
              city: newCustomer.address.city,
              houseNumber: newCustomer.address.houseNumber,
              street: newCustomer.address.street,
              supplement: newCustomer.address.supplement,
              zip: newCustomer.address.zip
            },
            email: newCustomer.email,
            phoneNumber: newCustomer.alternativePhone ? newCustomer.alternativePhone : ''
          }
        }
      }
      ).then((response) => {
        commit('clearMessages', {}, { root: true })
        commit('Transaction/removeTransactionId', 'personalData', { root: true })
        commit('changeView', 'personalDataChangeSuccess')
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    changeView (state, newView) {
      state.view = newView
    }
  }
}

export {
  PersonalDataModule
}
